/*API URL*/
export const account_api = 'https://api.annapurnasweetsnepal.com/accounts'
export const order_api = 'https://api.annapurnasweetsnepal.com/order'
export const product_api = 'https://api.annapurnasweetsnepal.com/product'
export const home_api = 'https://api.annapurnasweetsnepal.com/home'
export const base_api = 'https://api.annapurnasweetsnepal.com'